import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';

interface UnsavedChangesBarProps {
  visible: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

const UnsavedChangesBar: React.FC<UnsavedChangesBarProps> = ({ visible, saving, onSave, onDiscard }) => {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: '#0d3d50',
        color: '#fff',
        px: 3,
        py: 1.5,
        borderRadius: 0,
        mx: 0,
        mb: 0,
        mt: 0,
        boxShadow: '0 -4px 16px rgba(0,0,0,0.2)',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: '"Montserrat", sans-serif', fontSize: '0.82rem' }}>
        You have unsaved ordering changes
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<UndoIcon />}
          onClick={onDiscard}
          disabled={saving}
          sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)', '&:hover': { borderColor: '#fff' } }}
        >
          Discard
        </Button>
        <Button
          variant="contained"
          size="small"
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
          onClick={onSave}
          disabled={saving}
          sx={{ bgcolor: '#D4AC0D', '&:hover': { bgcolor: '#A8890A' } }}
        >
          {saving ? 'Saving...' : 'Save Order'}
        </Button>
      </Box>
    </Box>
  );
};

export default UnsavedChangesBar;
